/**
 * Schéma du contenu pédagogique (source : dossier racine `content/`).
 * Toute modification ici doit être reflétée dans tools/validate-content.js.
 */

export type Year = 9 | 10 | 11;
export const YEARS: Year[] = [9, 10, 11];

export type ChapterStatus = "draft" | "reviewed" | "published";

export interface Subject {
  id: string;
  name: string;
  shortName: string;
  icon: string; // classe Font Awesome
  color: string; // hex
  perDomain?: string;
}

export interface ChapterMeta {
  id: string;
  subjectId: string;
  title: string;
  years: Year[];
  order: number;
  status: ChapterStatus;
  /** Accessible sans abonnement Premium */
  free: boolean;
  estimatedMinutes: number;
}

export interface Catalog {
  version: number;
  years: Year[];
  subjects: Subject[];
  chapters: ChapterMeta[];
}

export type TheoryLevel = "quick" | "standard" | "detailed";
export const THEORY_LEVELS: TheoryLevel[] = ["quick", "standard", "detailed"];

export type ExerciseLevel = 1 | 2 | 3 | 4;
export type ExerciseType = "mcq" | "numeric" | "text";

export interface Mistake {
  /** Réponse fausse typique : index (mcq), nombre (numeric) ou chaîne (text) */
  answer: number | string;
  feedback: string;
}

export interface Exercise {
  id: string;
  level: ExerciseLevel;
  type: ExerciseType;
  prompt: string; // markdown
  choices?: string[];
  /** mcq : index de la bonne réponse — numeric : nombre — text : chaîne ou liste de chaînes acceptées */
  answer: number | string | string[];
  tolerance?: number;
  unit?: string;
  normalize?: "math" | "text";
  hint?: string;
  explanation: string; // markdown
  mistakes?: Mistake[];
}

export interface ChapterTest {
  exerciseIds: string[];
  passScore: number; // pourcentage
  durationMin: number;
}

export interface Chapter extends Omit<ChapterMeta, "order" | "free" | "estimatedMinutes"> {
  per?: string;
  objectives: string[];
  reviewedBy?: string | null;
  theory: Record<TheoryLevel, string>;
  examples: { title: string; body: string }[];
  exercises: Exercise[];
  test: ChapterTest;
  aiContext: string;
}

/** Chapitre + métadonnées du catalogue, tel que consommé par les écrans. */
export type FullChapter = Chapter & ChapterMeta;
